import React, { useState } from "react";
import { filterModels } from "../../../functions/filterModels";
import { calculatePriceLegs } from "../../../functions/calculatePrice";

export const ModelPicker = ({
  title,
  items,
  dims,
  material,
  setCompleted,
  onComplete,
  handleColorClick,
  setLegPrice,
  thickness,
}) => {
  const [activeColor, setActiveColor] = useState(false);
  const colors = filterModels(items, {
    dimsValue: parseInt(dims),
    material: material,
    thickness: parseInt(thickness),
  });
  return (
    <>
      <div className="conf-color-picker">
        <p className="marcellus-25-400">{title}</p>
        <div className="conf-color-picker__wrap">
          <div className="conf-color-picker__selected">
            {colors && colors.length ? (
              <>
                <img
                  className="conf-color-picker__selected-image"
                  src={
                    activeColor ? activeColor.image.url : colors[0].image.url
                  }
                  alt={
                    activeColor ? activeColor.image.alt : colors[0].image.alt
                  }
                />
                <p className="poppins-18-400">
                  {activeColor ? activeColor.name : colors[0].name}
                </p>
              </>
            ) : null}
          </div>
          <div className="conf-color-picker__items">
            {colors &&
              colors.length &&
              colors.map((color) => {
                return (
                  <div
                    onClick={() => {
                      setActiveColor(color);
                      handleColorClick(color);
                      setLegPrice(calculatePriceLegs(color));
                    }}
                    className="conf-color-picker__items-item"
                  >
                    <img
                      className="conf-color-picker__selected-image"
                      src={color.image.url}
                      alt={color.image.alt}
                    />
                    <p className="poppins-12-400">{color.name}</p>
                  </div>
                );
              })}
          </div>
        </div>
        <button
          type="button"
          disabled={!activeColor}
          className={`${
            !activeColor ? "hidden" : ""
          } conf-color-picker__btn btn green`}
          onClick={() => {
            setCompleted(true);
            onComplete();
          }}
        >
          Nastavi
        </button>
      </div>
    </>
  );
};
